/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { CONTACT_DETAILS } from '../../../utilities/constants';

const FALLBACK_COUNTRY = 'USA';

const getCountryContactDetails = (currentCountryIso) => {
  const { baanx, gov } = CONTACT_DETAILS;

  return baanx[currentCountryIso] && gov[currentCountryIso]
    ? {
        baanx: baanx[currentCountryIso],
        gov: gov[currentCountryIso],
      }
    : {
        baanx: baanx[FALLBACK_COUNTRY],
        gov: gov[FALLBACK_COUNTRY],
      };
};

const ContactInfo = ({ userCountry }) => {
  const { t: translate } = useTranslation();
  const { iso3166alpha3: countryIso } = userCountry;

  const { baanx: baanxDetails, gov: govDetails } = getCountryContactDetails(countryIso);

  return (
    <div className="text-f6 mt-4">
      <p className="mb-3">{translate('manage_card_setting_option_card_fees_contact_info_p0')}</p>
      <p className="mb-3">{translate('manage_card_setting_option_card_fees_contact_info_p1')}</p>
      <p className="mb-3">
        <Trans
          className="mt-5"
          i18nKey="manage_card_setting_option_card_fees_contact_info_p2"
          values={{
            name: baanxDetails.name,
            baanx_phone: baanxDetails.phone,
            baanx_email: baanxDetails.email,
            baanx_website: baanxDetails.website,
          }}
          components={[
            <a
              href="./"
              key="contact-link-1"
              className="pe-none text-decoration-none text-primary"
              rel="noreferrer"
            />,
            <a
              key="contact-link-2"
              className="text-decoration-none"
              href={`mailto:${baanxDetails.email}`}
              rel="noreferrer"
            />,
            <a
              key="contact-link-3"
              className=" text-decoration-none"
              href={`http://${baanxDetails.website}`}
              target="_blank"
              rel="noreferrer"
            />,
          ]}
        />
      </p>

      <p className="mb-3">
        <Trans
          className="mt-5"
          i18nKey="manage_card_setting_option_card_fees_contact_info_p3"
          values={{
            gov_phone: govDetails.phone,
            gov_website_prepaid: govDetails.website_prepaid,
            gov_website_complaint: govDetails.website_complaint,
          }}
          components={[
            <a
              href={`http://${govDetails.website_prepaid}`}
              target="_blank"
              key="contact-link-4"
              className=" text-decoration-none text-primary"
              rel="noreferrer"
            />,
            <a
              key="contact-link-5"
              className="pe-none text-decoration-none"
              style={{ whiteSpace: 'nowrap' }}
              href="./"
              rel="noreferrer"
            />,
            <a
              key="contact-link-6"
              className=" text-decoration-none text-primary"
              href={`http://${govDetails.website_complaint}`}
              target="_blank"
              rel="noreferrer"
            />,
          ]}
        />
      </p>
    </div>
  );
};

ContactInfo.propTypes = {
  userCountry: PropTypes.object.isRequired,
};

export default ContactInfo;
